import { categories } from "@/mocks/comics";

interface CategoriesProps {
  onSelect: (name: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <p className="text-sm font-semibold uppercase tracking-widest text-primary-600">
              主题分类
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              总能找到你爱的那一部
            </h2>
            <p className="mt-4 text-base text-foreground-600">
              八大热门主题，点击即可筛选对应类型的漫画作品。
            </p>
          </div>
          <a
            href="#comics"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            浏览全部作品
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {categories.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => onSelect(c.name)}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-all hover:-translate-y-1 hover:border-primary-200 hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span>
                <span className="block text-sm font-bold text-foreground-900 md:text-base">
                  {c.name}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">{c.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}